import { render } from "./trainDetail.vue?vue&type=template&id=7da79d90&scoped=true"
import script from "./trainDetail.vue?vue&type=script&lang=js"
export * from "./trainDetail.vue?vue&type=script&lang=js"

import "./trainDetail.vue?vue&type=style&index=0&id=7da79d90&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da79d90"]])

export default __exports__